module.exports = __webpack_public_path__ + "img/b6-5.bd54ca1.png";